<div class="modal-header">
  <h3 class="modal-title">You were invited to collaborate!</h3>
</div>
<div class="modal-body clearfix">
  <div class="container-fluid">
    <div class="col-lg-12">
      You have been invited to collaborate on {{ idea.title }}!
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-danger" (click)="reject()">Reject</button>
  <button class="btn btn-primary" (click)="accept()">Accept</button>
  <button class="btn" (click)="activeModal.close()">Decide Later ...</button>
</div>
